<template>
    <div class="second-search-bar-left">
        <controls @clearAllFilters="clearAllFilters"
                  id="controls"
                  :collapse="collapse"
                  :list-type="listType"
                  :localize-list="localizeList"/>

        <div class="blocks">
            <div v-show="filtersLoader" class="filters-loader">
                <base-loader size="50" weight="3"/>
            </div>

            <filters-block empty
                           v-if="showPriceTableSettings"
                           @toggle="togglePriceTable($event)"
                           :open="showFilters[0]"
                           :collapse="collapsePriceTable"
                           :title="localizeList.pricingTableUpper">
            </filters-block>

            <price-filter v-if="!getWindowSettings.hidePriceRangeFilter"
                          @toggle="toggleFilterBlock"
                          :open="showFilters[1]"
                          :collapse="collapseAll"
                          :rate="rate"
                          :tour-settings="tourSettings"
                          :availability-price="availabilityPrice"
                          :availability-place="availabilityPlace"
                          :price-loader="priceLoader"
                          :tour-price-limit="tourPriceLimit"
                          />

            <tour-options v-if="!getWindowSettings.hideTourOptionsFilter"
                          @toggle="toggleFilterBlock"
                          :open="showFilters[2]"
                          :collapse="collapseAll"
                          :tour-program-list="tourProgramList"
                          :tour-program-checked="tourProgramChecked"
                          :headline-checkbox="headlineCheckbox.tourProgram" />

            <filters-block v-if="!getWindowSettings.hideAccommodationFilter"
                           parent
                           @toggle="toggleFilterBlock($event)"
                           :open="showFilters[3]"
                           :collapse="collapseAll"
                           :title="localizeList.accommodation"
                           :headline-checkbox="headlineCheckbox"
                           :show-selected-hotels="showSelectedHotels">
                <city @toggle="toggleFilterBlock"
                      class="sub-block"
                      :open="showAccomodationFilters[0]"
                      :collapse="collapseAll"
                      :tour-cities-list="tourCitiesList"
                      :tour-cities-checked="tourCitiesChecked"
                      :headline-checkbox="headlineCheckbox.cities"/>

                <resort @toggle="toggleFilterBlock"
                        class="sub-block"
                        :open="showAccomodationFilters[1]"
                        :collapse="collapseAll"
                        :tour-resort-list="tourResortList"
                        :tour-resort-checked="tourResortChecked"
                        :headline-checkbox="headlineCheckbox.resorts"/>

                <category @toggle="toggleFilterBlock"
                          class="sub-block"
                          :open="showAccomodationFilters[2]"
                          :collapse="collapseAll"
                          :tour-category-list="tourCategoryList"
                          :tour-category-checked="tourCategoryChecked"
                          :headline-checkbox="headlineCheckbox.category"/>

                <pansion @toggle="toggleFilterBlock"
                         class="sub-block"
                         :open="showAccomodationFilters[3]"
                         :collapse="collapseAll"
                         :tour-food-list="tourFoodList"
                         :tour-food-checked="tourFoodChecked"
                         :headline-checkbox="headlineCheckbox.pansion"/>

                <hotel-types v-if="!getWindowSettings.hideHotelTypeFilter"
                             @toggle="toggleFilterBlock"
                             class="sub-block"
                             :open="showAccomodationFilters[4]"
                             :collapse="collapseAll"
                             :tour-hotel-type-list="tourHotelTypeList"
                             :tour-hotel-type-checked="tourHotelTypeChecked"
                             :hide-hotel-type-combination="hideHotelTypeCombination"
                             :tour-hotel-type-combination="tourHotelTypeCombination"
                             :headline-checkbox="headlineCheckbox.hotelType"/>

                <hotel @toggle="toggleFilterBlock"
                       class="sub-block"
                       :open="showAccomodationFilters[5]"
                       :collapse="collapseAll"
                       :tour-hotel-list="tourHotelList"
                       :tour-hotel-checked="tourHotelChecked"
                       :hide-hotel-check="hideHotelCheck"
                       :tour-hotel-combination="tourHotelCombination"
                       :headline-checkbox="headlineCheckbox.hotels"
                       :show-selected-hotels="showSelectedHotels"/>
            </filters-block>

            <filters-block v-if="!getWindowSettings.hideFlightFilter" 
                           parent
                           @toggle="toggleFilterBlock($event)"
                           :open="showFilters[4]"
                           :collapse="collapseAll"
                           :title="localizeList.flightUpper2">

                <flight-class @toggle="toggleFilterBlock"
                              class="sub-block"
                              :open="showFlightFilters[0]"
                              :collapse="collapseAll"
                              :tour-class-list="tourClassList"
                              :tour-class-multy="tourClassMulty"
                              :tour-class-checked="tourClassChecked"/>

                <directs @toggle="toggleFilterBlock"
                         class="sub-block"
                         :open="showFlightFilters[1]"
                         :collapse="collapseAll"
                         :tour-transplantation-list="tourTransplantationList"/>

                <time-filter @toggle="toggleFilterBlock" class="sub-block" :open="showFlightFilters[2]" :collapse="collapseAll" />

                <departure-airport @toggle="toggleFilterBlock"
                                   class="sub-block"
                                   :open="showFlightFilters[3]"
                                   :collapse="collapseAll"
                                   :tour-departure-list="tourDepartureList"
                                   :tour-departure-airports-checked="tourDepartureAirportsChecked"/>

                <arrival-airport @toggle="toggleFilterBlock"
                                 class="sub-block"
                                 :open="showFlightFilters[4]"
                                 :collapse="collapseAll"
                                 :tour-arrival-list="tourArrivalList"
                                 :tour-arrival-airports-checked="tourArrivalAirportsChecked"/>

                <airlines @toggle="toggleFilterBlock"
                          class="sub-block"
                          :open="showFlightFilters[5]"
                          :collapse="collapseAll"
                          :tour-airline-list="tourAirlineList"
                          :tour-airline-multy="tourAirlineMulty"
                          :tour-airlines-checked="tourAirlinesChecked"/>

            </filters-block>
        </div>

        <div class="apply-block">
            <base-button @click.native="clearAllFilters"
                         size="15"
                         padding="8px"
                         background="var(--lighten-6-color)"
                         color="#727272">
                {{localizeList.resetFlightsUpper}}
            </base-button>

            <base-button v-if="useApplyFiltersButton"
                         @click.native="applyAllChanges"
                         class="ml-5"
                         size="15"
                         padding="8px">
                {{localizeList.applyUpper}}
            </base-button>
        </div>

    </div>
</template>

<script>
    import FiltersBlock from "./filtersBlock";
    import Controls from "./controls";
    import PriceFilter from "./priceFilter";
    import TourOptions from "./tourOptions";
    import City from "./city";
    import Resort from "./resort";
    import Category from "./category";
    import Pansion from "./pansion";
    import HotelTypes from "./hotelTypes";
    import Hotel from "./hotel";
    import FlightClass from "./flightClass";
    import Directs from "./directs";
    import TimeFilter from "./timeFilter";
    import DepartureAirport from "./departureAirport";
    import ArrivalAirport from "./arrivalAirport";
    import Airlines from "./airlines";

    import { bus } from "../../../../main"

    export default {
        name: "secondSearchBarLeft",
        components: {
            Airlines,
            ArrivalAirport,
            DepartureAirport,
            TimeFilter,
            Directs,
            FlightClass,
            Hotel,
            HotelTypes,
            Pansion,
            Category,
            Resort,
            City,
            TourOptions,
            PriceFilter,
            Controls,
            FiltersBlock
        },
        props: {
            rate: {
                type: Object,
            },
            tourSettings: {
                type: Object,
            },
            availabilityPrice: {
                type: Array,
                required: true
            },
            availabilityPlace: {
                type: Array,
                required: true
            },
            tourProgramList: {
                type: Array,
                required: true
            },
            tourProgramChecked: {
                type: Object,
                required: true
            },
            tourCitiesList: {
                type: Array,
                required: true
            },
            tourCitiesChecked: {
                type: Object,
                required: true
            },
            tourResortList: {
                type: Array,
                required: true
            },
            tourResortChecked: {
                type: Object,
                required: true
            },
            tourCategoryList: {
                type: Array,
                required: true
            },
            tourCategoryChecked: {
                type: Object,
                required: true
            },
            tourFoodList: {
                type: Array,
                required: true
            },
            tourFoodChecked: {
                type: Object,
                required: true
            },
            tourHotelTypeList: {
                type: Array,
                required: true
            },
            tourHotelTypeChecked: {
                type: Object,
                required: true
            },
            tourHotelList: {
                type: Array,
                required: true
            },
            tourHotelChecked: {
                type: Object,
                required: true
            },
            tourClassList: {
                type: Array,
                required: true
            },
            tourClassChecked: {
                type: Object,
                required: true
            },
            tourClassMulty: {
                type: Object,
                required: true
            },
            tourTransplantationList: {
                type: Array,
                required: true
            },
            departureTime: {
                type: Array,
                required: true
            },
            arrivalTime: {
                type: Array,
                required: true
            },
            tourDepartureList: {
                type: Array,
                required: true
            },
            tourDepartureAirportsChecked: {
                type: Object,
                required: true
            },
            tourArrivalList: {
                type: Array,
                required: true
            },
            tourArrivalAirportsChecked: {
                type: Object,
                required: true
            },
            tourAirlineList: {
                type: Array,
                required: true
            },
            tourAirlinesChecked: {
                type: Object,
                required: true
            },
            tourAirlineMulty: {
                type: Object,
                required: true
            },
            collapse: {
                type: Boolean,
                required: true
            },
            priceLoader: {
                type: Boolean,
                required: true
            },
            listType: {
                type: String,
                required: true
            },
            tourPriceLimit: {
                type: Array,
                required: true
            },
            leftFiltersUpdate: {
                type: Number,
                default: 0
            },
            hideHotelTypeCombination: {
                type: Boolean,
                default: false
            },
            tourHotelTypeCombination: {
                type: Boolean,
                default: false
            },
            hideHotelCheck: {
                type: Boolean,
                default: false
            },
            tourHotelCombination: {
                type: Boolean,
                default: false
            },
            headlineCheckbox: {
                type: Object,
                required: true
            },
            showSelectedHotels: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            getWindowSettings() {
                return window.settings;
            },
            showPriceTableSettings() {
                const settings = this.$store.getters['getSettings'];
                return window.settings.priceTableOpen !== undefined ? window.settings.priceTableOpen : settings.ShowPriceTableInSearch
            },
            useApplyFiltersButton() {
                // return true
                return this.$store.getters['getSettings'].UseApplyFiltersButton;
            }
        },
        data() {
            return {
                collapseAll: 0,
                showPriceTable: false,
                filtersLoader: false,
                showFilters: [0, 0, 0, 0, 0],
                showAccomodationFilters: [0, 0, 0, 0, 0, 0],
                showFlightFilters: [0, 0, 0, 0, 0, 0],
                collapsePriceTable: 0
            }
        },
        created() {
            bus.$on("change-search-type", () => {
                this.$nextTick(() => {
                    this.scroll()
                })
            });
            bus.$on("tour_second_filters_changed", () => {
                this.filtersLoader = false;
            });
            bus.$on("tour_second_filters_loaded", () => {
                this.filtersLoader = false;
            });
            window.addEventListener("scroll", this.scroll);

            // document.body.style.minWidth = "1380px"
        },
        mounted() {
            this.showFilterBySettings()
        },
        methods: {
            openAllFilters(settings = {}){
                const isVerticalFilters = settings.FiltersDisplayOptions
                const hasSetting = this.getWindowSettings.showAllVerticalFilters

                if(isVerticalFilters && hasSetting){
                    this.showFilters = this.showFilters.map((_, idx) => !idx ? 0 : 1)
                    this.showAccomodationFilters = this.showAccomodationFilters.map(() => 1)
                    this.showFlightFilters = this.showFlightFilters.map(() => 1)
                }
            },
            applyAllChanges() {
                this.filtersLoader = true;
                this.$emit('applyAllChanges')
            },
            showFilterBySettings() {
                const settings = this.$store.getters['getSettings'];
                let type = window.settings.tourAdditionalFilterOpen !== undefined ? window.settings.tourAdditionalFilterOpen : settings.ExtraFilterToShowInSearch;
                type = type < 6 && type > 0 ? type : null;

                if (type === 1 && window.settings.priceTableOpen === false) return;

                this.$set(this.showFilters, type-1, this.showFilters[type-1] + 1);

                if (type === 1) this.togglePriceTable(true);
                if (type === 2) this.scroll();
            },
            togglePriceTable(e) {
                this.showPriceTable = e;
                if (!e) return;

                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                })
            },
            async toggleFilterBlock() {
                await this.$nextTick();

                this.$emit("toggleFilterBlock", this.showPriceTable)
            },
            scroll() {
                const secondSearchBar = document.querySelector("#second-search-bar");
                const priceTable = document.querySelector("#price-table");
                const leftFilters = document.querySelector(".second-search-bar-left");

                const leftFiltersMarginX = 60;

                if (priceTable) {
                    priceTable.style.marginLeft = leftFilters.offsetWidth + leftFiltersMarginX + 16 + "px";
                }

                if (!priceTable)
                    secondSearchBar.style.width = leftFilters.clientWidth + leftFiltersMarginX + "px";
                else
                    secondSearchBar.style.width = "100%";

                leftFilters.style.position = "relative";
                leftFilters.style.top = "unset";

                if (priceTable) {
                    leftFilters.style.position = "absolute";
                }
            },
            clearAllFilters() {
                this.filtersLoader = true;
                this.$emit("clearAllFilters");
            }
        },
        watch: {
            showPriceTable(val) {
                this.$emit('togglePriceTable', val);

                this.$nextTick(() => {
                    this.scroll();
                })
            },
            leftFiltersUpdate(val) {
                if (!val) {
                    this.$parent.setTopSpace();
                }
                setTimeout(() => {
                    this.scroll()
                }, 0)
            },
            collapseAll() {
                this.collapsePriceTable++
            },
            tourSettings(value){
                if(!value) return;
                this.openAllFilters(value)
            }
        },
        beforeDestroy() {
            window.removeEventListener("scroll", this.scroll)
        }
    }
</script>

<style scoped>

    .second-search-bar-left {
        position: relative;
        margin: 18px 0 18px 60px;
        min-width: 375px;
        max-width: 375px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
        align-self: flex-start;
        z-index: 10;
    }

    .second-search-bar-left .blocks {
        /*overflow-y: scroll;*/
        overflow-x: hidden;
        /*position: relative;*/
    }

    .second-search-bar-left .blocks .filters-loader {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(200, 200, 200, .5);
    }

    .second-search-bar-left .filters-block {
        border-top: 1px solid var(--lighten-4-color);
    }

    .sub-block /deep/ .header {
        padding-left: 40px;
    }

    .apply-block {
        padding: 20px;
        background-color: var(--white-color);
        display: flex;
        justify-content: flex-end;
    }

</style>